import {defineRouting} from 'next-intl/routing';
import {Pathnames} from 'next-intl/routing';
 
export const locales = ['en-EU', 'de-AT'] as const;
export const defaultLocale = 'de-AT' as const;

/**
 * Converts German umlauts to ASCII equivalents for URL-friendly slugs
 * ä -> ae, ö -> oe, ü -> ue, ß -> ss
 */
function toAsciiSlug(path: string): string {
  return path
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss');
}

// Define localized pathnames
export const pathnames = {
  '/': '/',
  '/about': {
    'en-EU': '/about',
    'de-AT': toAsciiSlug('/über')
  },
  '/impressum': {
    'en-EU': '/imprint',
    'de-AT': '/impressum'
  },
  '/privacy': {
    'en-EU': '/privacy',
    'de-AT': '/datenschutz'
  },
  '/terms': {
    'en-EU': '/terms',
    'de-AT': '/nutzungsbedingungen'
  },
  '/waitlist': {
    'en-EU': '/waitlist',
    'de-AT': '/warteliste'
  },
  '/gtc': {
    'en-EU': '/gtc',
    'de-AT': '/agb'
  },
  '/beta-terms': {
    'en-EU': '/beta-terms',
    'de-AT': '/beta-nutzungsvertrag'
  },
  '/tenant-not-found': {
    'en-EU': '/tenant-not-found',
    'de-AT': '/verein-nicht-gefunden'
  }
} satisfies Pathnames<typeof locales>;

export const routing = defineRouting({
  locales,
  localePrefix: 'as-needed',
  defaultLocale,
  pathnames
});